import { render, staticRenderFns } from "./NextLink.vue?vue&type=template&id=56e093c3&lang=html&"
import script from "./NextLink.vue?vue&type=script&lang=js&"
export * from "./NextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports